<div *ngIf="!isIE; else warning">
    <!-- Header Navbar -->
    <div class="stickyHeader">
        <app-header></app-header>
    </div>
    <!-- Navbar Downwards -->
    <div [class]="showSideMenu() ? 'layoutWithSideMenu' : 'layoutNoSideMenu'"
        [class.mobile-side-menu-open]="mobileSideMenuOpen">
        <!-- left Bar background  -->
        <div [hidden]="!showSideMenu()" class="zBelowHeader">
            <!-- Left Sidemenu -->
<!--            <div class="leftBar"></div>
            <div>
                <app-search-panel
                    (filter)="filter($event)"
                    (reset)="reset($event)"
                    [urlEqualsComposer]="equalsString('/composer')"
                ></app-search-panel>
                <app-sidemenu-new
                    class="sidemenu content-sidemenu"
                    [urlEqualsComposer]="equalsString('/composer')"
                ></app-sidemenu-new>
            </div>-->
            <!-- BAUTAGEBUCH: remove this ngIf wrapper when removing bautagebuch module -->
            <div *ngIf="!startsWithString('/bautagebuch')">
                <app-search-panel
                    (filter)="filter($event)"
                    (reset)="reset($event)"
                    [urlEqualsComposer]="equalsString('/composer')"
                ></app-search-panel>
                <app-sidemenu-new
                    class="sidemenu content-sidemenu"
                    [urlEqualsComposer]="equalsString('/composer')"
                ></app-sidemenu-new>
            </div>
        </div>
        <!-- Main Content -->
        <div [class]="showSideMenu() ? 'content' : 'contentNoSideMenu'">
            <router-outlet></router-outlet>
        </div>
        <div #emptyDropdown></div>
    </div>
</div>

<!--router-outlet></router-outlet-->

<ng-template #warning>
    <div class="warningscreen"></div>
</ng-template>
<app-footer class="footer"></app-footer>
